<template>
    <div class="head-fi wrap">
        <p class="numfiche">
            <strong>{{ code }}</strong><span v-if="ot"> - {{ ot }}</span>
        </p>
        <p class="det">{{detenteur.raison_sociale}} {{detenteur.ville }}</p>
        <p class="install">
            {{ installation.nom }}
            {{ (installation.marque) ? ' - ' + installation.marque : '' }}
            {{ (installation.modele) ? ' - ' + installation.modele : '' }}
        </p>
        <div v-if="gotFluide" class="btn refrigerant">
            <i class="icon-fluid"></i>
            {{ installation.fluide.nom }}
        </div>
        <div v-if="gotFluide">
            CHARGE
            <br> TOTALE
            <br>
            <strong>{{ installation.charge }}</strong> kg
        </div>
        <div v-if="gotFluide && isFibsdd">
            TONNAGE
            <br> ÉQUIVALENT CO<span class="smallexp">2</span>
            <br>
            <strong>{{ installation.tonnage }}</strong>
        </div>
        <div class="clear"></div>
    </div>
</template>

<script>

    export default {
        data() {
            return {}
        },
        props: {
            code: '',
            ot: '',
            detenteur: {},
            installation: {},
            gotFluide: null,
            isFibsdd: null
        },
        computed: {},
        methods: {},
        components: {}
    }

</script>

<style>
    .head-fi {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        min-height: 90px;
        background-color: #eee;
        margin-bottom: 20px;
        padding: 10px;
    }

    .head-fi > p {
        width: 100%;
    }

    .head-fi > div:not(.clear) {
        flex: 1 1 30%;
        min-width: 90px;
        min-height: 35px;
        margin-top: 10px;
        color: #666666;
        font-size: 1.2rem;
        font-weight: 400;
        line-height: 1.2;
    }

    .head-fi > div:not(.clear) strong {
        color: #333333;
        font-size: 1.5rem;
        font-weight: 700;
    }

    .head-fi > div:not(.clear):not(.refrigerant) {
        padding-left: 15px;
    }

    .head-fi > div:not(.clear).refrigerant {
        height: auto;
        color: #fff;
        font-size: 1.8rem;
        font-weight: 700;
        word-break: break-word;
    }

    .head-fi p {
        text-transform: uppercase;
    }

    .head-fi p.install {
        color: #000000;
        font-size: 1.8rem;
        font-weight: 400;
    }

    .head-fi p.det {
        color: #999;
        font-size: 1.5rem;
        font-weight: 400;
    }

    .numfiche span {
        color: #5698d2;
    }

    @media (max-width: 365px) {
        .head-fi > div:not(.clear).refrigerant {
            font-size: 15px;
        }
    }

    @media (max-width: 330px) {
        .head-fi > div:not(.clear).refrigerant {
            font-size: 12px;
        }
    }

</style>



// WEBPACK FOOTER //
// SmallRecap.vue?39753d48